const StoreExpansion = () => import(/* webpackChunkName: "UnassignedStore" */ '@/views/StoreExpansion')
const StoreMapping = () => import(/* webpackChunkName: "StoreExpansionMapping" */ '@/views/StoreExpansion/storeMapping')
const StoreMappingDetail = () => import(/* webpackChunkName: "StoreMappingDetail" */ '@/views/StoreExpansion/storeMappingDetail')
const VisitSellIn = () => import(/* webpackChunkName: "VisitSellIn" */ '@/views/StoreExpansion/visitSellIn')
const VisitSellInDetail = () => import(/* webpackChunkName: "VisitSellInDetail" */ '@/views/StoreExpansion/visitSellInDetail')
const StoreExpansionSearch = () => import(/* webpackChunkName: "StoreExpansionSearch" */ '@/views/Search/storeExpansionSearch')
const storeExpansionRouter = [
  {
    // path: '', 或者 重定向
    path: '/storeExpansion',
    component: StoreExpansion,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Store Expansion'
    }
  },
  {
    path: '/storeExpansion/storeMapping',
    component: StoreMapping,
    meta: {
      title: 'Store Mapping'
    }
  },
  {
    path: '/storeExpansion/storeMappingDetail',
    component: StoreMappingDetail,
    meta: {
      title: 'Store Mapping Detail'
    }
  },
  {
    path: '/storeExpansion/visitSellIn',
    component: VisitSellIn,
    meta: {
      title: 'Visit Sell-in'
    }
  },
  {
    path: '/storeExpansion/visitSellInDetail',
    component: VisitSellInDetail,
    meta: {
      title: 'Visit Sell-in Detail'
    }
  },
  {
    path: '/storeExpansion/search',
    component: StoreExpansionSearch,
    meta: {
      title: 'Store Expansion Search'
    }
  }
]

export default storeExpansionRouter
